export default {"src":"/_next/static/media/drive-logo.b0f1fd11.svg","height":43,"width":44,"blurWidth":0,"blurHeight":0};